$(document).ready(function(){
  $(".site-btn").click(function (event) {
      event.preventDefault();
      $("html, body").animate({
          scrollTop: $("#product-section").offset().top
      }, 1500); // Adjust timing as needed
  });
});

$(document).ready(function () {
  var $hearingSection = $(".hearing-section");

  // Function to check if element is in viewport
  function isInViewport($element) {
    var rect = $element[0].getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  // Add hover effect when scrolled into view
  function handleScroll() {
    if (isInViewport($hearingSection)) {
      $hearingSection.addClass("hover-active");
    } else {
      $hearingSection.removeClass("hover-active");
    }
  }

  // Add click event for mobile
  $hearingSection.on("click", function () {
    $(this).toggleClass("hover-active");
  });

  // Listen for scroll event
  $(window).on("scroll", handleScroll);
});


const accordionItemHeaders = document.querySelectorAll(
  ".accordion-item-header"
);

accordionItemHeaders.forEach((accordionItemHeader) => {
  accordionItemHeader.addEventListener("click", (event) => {
    // Uncomment in case you only want to allow for the display of only one collapsed item at a time!

    const currentlyActiveAccordionItemHeader = document.querySelector(
      ".accordion-item-header.active"
    );
    if (
      currentlyActiveAccordionItemHeader &&
      currentlyActiveAccordionItemHeader !== accordionItemHeader
    ) {
      currentlyActiveAccordionItemHeader.classList.toggle("active");
      currentlyActiveAccordionItemHeader.nextElementSibling.style.maxHeight = 0;
    }
    accordionItemHeader.classList.toggle("active");
    const accordionItemBody = accordionItemHeader.nextElementSibling;
    if (accordionItemHeader.classList.contains("active")) {
      accordionItemBody.style.maxHeight = accordionItemBody.scrollHeight + "px";
    } else {
      accordionItemBody.style.maxHeight = 0;
    }
  });
});